/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Move_Line_DownInputs */

const en_shortcut_keys_name_move_line_down = /** @type {(inputs: Shortcut_Keys_Name_Move_Line_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move Line Down`)
};

const fr_shortcut_keys_name_move_line_down = /** @type {(inputs: Shortcut_Keys_Name_Move_Line_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deplacer une ligne vers le bas`)
};

const de_shortcut_keys_name_move_line_down = /** @type {(inputs: Shortcut_Keys_Name_Move_Line_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linie nach unten verschieben`)
};

const it_shortcut_keys_name_move_line_down = /** @type {(inputs: Shortcut_Keys_Name_Move_Line_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sposta la linea verso il basso`)
};

const ru_shortcut_keys_name_move_line_down = /** @type {(inputs: Shortcut_Keys_Name_Move_Line_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сдвинуть линию вниз`)
};

const es_shortcut_keys_name_move_line_down = /** @type {(inputs: Shortcut_Keys_Name_Move_Line_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mover línea hacia abajo`)
};

const zh_cn2_shortcut_keys_name_move_line_down = /** @type {(inputs: Shortcut_Keys_Name_Move_Line_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`向下移动线路`)
};

const ja_shortcut_keys_name_move_line_down = /** @type {(inputs: Shortcut_Keys_Name_Move_Line_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`行を下に移動`)
};

const hi_shortcut_keys_name_move_line_down = /** @type {(inputs: Shortcut_Keys_Name_Move_Line_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लाइन को नीचे ले जाएं`)
};

const pt_pt2_shortcut_keys_name_move_line_down = /** @type {(inputs: Shortcut_Keys_Name_Move_Line_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deslizar a linha para baixo`)
};

/**
* | output |
* | --- |
* | "Move Line Down" |
*
* @param {Shortcut_Keys_Name_Move_Line_DownInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_move_line_down = /** @type {((inputs?: Shortcut_Keys_Name_Move_Line_DownInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Move_Line_DownInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_move_line_down(inputs)
	if (locale === "de") return de_shortcut_keys_name_move_line_down(inputs)
	if (locale === "it") return it_shortcut_keys_name_move_line_down(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_move_line_down(inputs)
	if (locale === "es") return es_shortcut_keys_name_move_line_down(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_move_line_down(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_move_line_down(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_move_line_down(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_move_line_down(inputs)
	return en_shortcut_keys_name_move_line_down(inputs)
});